<template>
	<div>
		<CCard>
			<CCardHeader>
				<div>
					<h5 class="d-inline-block mb-0">Liste des paiements</h5>
					<CButton
						class="float-right"
						@click="$refs.addPaymentModal.showModal = true"
						color="primary"
						>Ajouter un paiement</CButton
					>
				</div>
			</CCardHeader>
			<CCardBody>
				<div class="table-responsive">
					<table class="table table-striped">
						<thead>
							<tr>
								<th>ID</th>
								<th>Numéro de transaction</th>
								<th>Date</th>
								<th>Code d'erreur</th>
								<th>Montant</th>
								<th>Statut</th>
								<th>Méthode</th>
								<th>Informations complémentaires</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							<template v-for="payment in payments">
								<tr>
									<td>{{ payment.id }}</td>
									<td>{{ payment.transactionid }}</td>
									<td>{{ $moment(payment.createdAt).format('DD/MM/YYYY HH:mm') }}</td>
									<td>{{ payment.info }}</td>
									<td>{{ payment.amount }} €</td>
									<td>
										<CBadge v-if="payment.status === 0" color="danger">Erreur</CBadge>
										<CBadge v-else-if="payment.status === 1" color="success"
											>Succès</CBadge
										>
										<CBadge v-else color="danger">Erreur inconnue</CBadge>
									</td>
									<td>
										{{ paymentTranslation[payment.method] }}
									</td>
									<td>
										{{ payment.additionalInfo }}
									</td>
									<td class="text-center">
										<a
											class="icon-action"
											href="#"
											@click.prevent="removePayment(payment)">
											<CIcon name="cil-trash" />
										</a>
									</td>
								</tr>
							</template>
						</tbody>
					</table>

					<h5>
						Reste à payer:
						<span class="font-weight-bold">{{ this.remainingToPay.toLocaleString() }} €</span>
					</h5>
				</div>
			</CCardBody>
		</CCard>
		<AddPaymentModal v-on:refresh="refresh" :payments="payments" :order="order" ref="addPaymentModal" />
	</div>
</template>

<script>
	import AddPaymentModal from '../../../../../components/modals/AddPaymentModal';

	export default {
		components: { AddPaymentModal },

		props: {
			order: Object,
		},

		data() {
			return {
				canAddPayment: false,
				payments: [],
				paymentTranslation: {
					'payment.credit_card': 'Carte bancaire',
					'payment.tpe': 'Carte bancaire (TPE)',
					'payment.paypal': 'Paypal',
					'payment.cash': 'Espèces',
					'payment.check': 'Chèque',
					'payment.bank_transfer': 'Virement',
					'payment.credit_note': 'Avoir',
					'payment.free': 'Gratuit',
					'payment.gift': 'Cadeau',
					'payment.reshipment': 'Réexpédition',
					'payment.dealer': 'Revendeur',
				},
			};
		},

		computed: {
			remainingToPay() {
				if (this.order === null) {
					return 0;
				}

				return (
					parseFloat(this.order.priceTotal + this.order.taxTotal) -
					this.payments.reduce((acc, el) => acc + parseFloat(el.amount), 0)
				);
			},
		},

		watch: {
			order() {
				this.refresh(false);
			},
		},

		methods: {
			async updateCanAddPayment() {
				await this.getPayments();

				if (this.remainingToPay === 0) {
					this.canAddPayment = false;
					return true;
				}

				this.$axios.get(`${this.order['@id']}/order_items`).then(res => {
					let hasError = false;
					for (let item of res.data['hydra:member']) {
						if (!item.price) {
							hasError = true;
							return true;
						}
					}

					this.canAddPayment = !hasError;
				});
			},

			async getPayments() {
				await this.$axios
					.get(`/api/orders/${this.$route.params.id}/payments`)
					.then(res => {
						this.payments = res.data['hydra:member'];
					})
					.catch(err => {
						this.$toast.error(
							"Une erreur s'est produite lors de la récupération des paiements de la commande"
						);
					});
			},

			removePayment(item) {
				this.$axios.delete(item['@id']).then(() => {
					this.$emit('refresh');
					this.getPayments();
				});
			},

			refresh(shouldEmit = true) {
				this.updateCanAddPayment();
				if (shouldEmit) {
					this.$emit('refresh');
				}
			},
		},
		mounted() {
			this.updateCanAddPayment();
		},
	};
</script>
